const prefix = 'DimContract';

export enum DimContractField {
  ID = `${prefix}.id`,
  VARIANT = `${prefix}.variant`,
  PLANNED_VALUE = `${prefix}.plannedValue`,
  PLANNED_VALUE_NORMALIZED = `${prefix}.plannedValueNormalized`,
  SUPPLIER_ID = `${prefix}.supplierId`,
  IS_ACTIVE = `${prefix}.isActive`,
  PRIMARY_SOURCE_REFERENCE = `${prefix}.primarySourceReference`,
}
